import React from 'react';
import { Text } from 'components';
import { Avatar } from 'components/Tailwindcss';
import { theme } from 'lib';
import { GridCell, Score, ScoreDisplay, TeamScore, TeamsGrid } from '../styles';

const GameHeader = ({ game }) => {
  const homeScore = parseInt(game.score?.home) || 0;
  const awayScore = parseInt(game.score?.away) || 0;
  const hasScore = game.status === 'finished' || game.status === 'in-play';

  if (hasScore) {
    return (
      <ScoreDisplay>
        <TeamScore>
          <Avatar src={game.home?.avatar} size={80}>
            {game.home?.name?.[0]}
          </Avatar>
          <Text h4 bold center>
            {game.home?.name || 'TBD'}
          </Text>
          <Score color={homeScore > awayScore ? '#4CAF50' : theme.GREY_80}>{homeScore}</Score>
        </TeamScore>

        <Text h2 col={theme.GREY_60}>
          -
        </Text>

        <TeamScore>
          <Avatar src={game.away?.avatar} size={80}>
            {game.away?.name?.[0]}
          </Avatar>
          <Text h4 bold center>
            {game.away?.name || 'TBD'}
          </Text>
          <Score color={awayScore > homeScore ? '#4CAF50' : theme.GREY_80}>{awayScore}</Score>
        </TeamScore>
      </ScoreDisplay>
    );
  }

  return (
    <TeamsGrid>
      {/* Row 1: Logos */}
      <GridCell position="left">
        <Avatar src={game.home?.avatar} size={80}>
          {game.home?.name?.[0]}
        </Avatar>
      </GridCell>
      <GridCell position="center">
        <Text h3 col={theme.GREY_60}>
          VS
        </Text>
      </GridCell>
      <GridCell position="right">
        <Avatar src={game.away?.avatar} size={80}>
          {game.away?.name?.[0]}
        </Avatar>
      </GridCell>

      {/* Row 2: Team Names */}
      <GridCell position="left">
        <Text h4 bold center>
          {game.home?.name || 'TBD'}
        </Text>
      </GridCell>
      <GridCell position="center" />
      <GridCell position="right">
        <Text h4 bold center>
          {game.away?.name || 'TBD'}
        </Text>
      </GridCell>

      {/* Row 3: Home/Away Labels */}
      <GridCell position="left">
        <Text c1 col={theme.GREY_60} center>
          Home
        </Text>
      </GridCell>
      <GridCell position="center" />
      <GridCell position="right">
        <Text c1 col={theme.GREY_60} center>
          Away
        </Text>
      </GridCell>
    </TeamsGrid>
  );
};

export default GameHeader;
